export default {
  'pages.common.save': '保存',
  'pages.common.cancel': 'キャンセル',
  'pages.common.confirm': 'OK',
  'pages.common.ok': 'OK',
  'pages.common.delete': '削除',
  'pages.common.edit': '編集',
  'pages.common.add': '追加',
  'pages.common.append': '追加',
  'pages.common.search': '検索',
  'pages.common.reset': 'リセット',
  'pages.common.submit': '送信',
  'pages.common.back': '戻る',
  'pages.common.close': '閉じる',
  'pages.common.export': 'エクスポート',
  'pages.common.import': 'インポート',
  'pages.common.refresh': '更新',
  'pages.common.detail': '詳細',
  'pages.common.copy': 'コピー',
  'pages.common.operation': '操作',
  'pages.common.view': '表示',
  'pages.common.download': 'ダウンロード',
  'pages.common.upload': 'アップロード',
  'pages.common.yes': 'はい',
  'pages.common.no': 'いいえ',
  'pages.common.loading': '読み込み中…',
  'pages.common.more': 'その他',
  'pages.common.all': 'すべて',
  'pages.common.createSuccess': '追加しました',
  'pages.common.saveSuccess': '保存しました',
  'pages.common.deleteSuccess': '削除しました',
  'pages.common.deleteFailed': '削除に失敗しました',
  'pages.common.saveFailed': '保存に失敗しました',
  'pages.common.loadFailed': '読み込みに失敗しました',
  'pages.common.requiredField': '必須項目です',
  'pages.common.selectedCount': '{count} 件を選択',
  'pages.common.clearSelection': '選択を解除',
  'pages.common.totalRecords': '全 {total} 件',
  'pages.common.batchDeleteCount': '一括削除 ({count})',
  'pages.common.statusSuccess': '成功',
  'pages.common.statusFailed': '失敗',
  'pages.common.timeRangeStart': '開始時刻',
  'pages.common.timeRangeEnd': '終了時刻',
  'pages.common.unnamed': '名称未設定',
  'pages.common.operationFailedRetry': '操作に失敗しました。再試行してください。',
  'pages.common.batchDeleteSuccess': '一括削除が完了しました',
  'pages.common.batchDeleteFailed': '一括削除に失敗しました。再試行してください。',
  'pages.common.nItemsFailed': '{count} 件が失敗しました',
  'pages.common.enable': 'Enable',
  'pages.common.disable': 'Disable',
  'pages.common.statusNormal': 'Active',
  'pages.common.statusDisabled': 'Disabled',
  'pages.common.selectOrganization': 'Select organization',
  'pages.common.batchDeleteTitle': 'Confirm batch delete',
  'pages.common.downloadingTemplate': 'Downloading template…',
  'pages.common.templateDownloadSuccess': 'Template downloaded',
  'pages.common.templateDownloadFailed': 'Download failed. Please try again.',
};
